import { createAppStore } from '@store/createAppStore';

import { INITIAL_COLLECTION_DETAILS_STATE } from './defaultVals';
import {
  ActionNote,
  ATGLookupValue,
  CollectionDetailsState,
  CollectionsTier,
  IComment,
} from './types';

const [collectionDetailsStore, setCollectionDetailsStore] =
  createAppStore<CollectionDetailsState>(
    {
      isCollectionLoading: false,
      isLoading: false,
      isError: false,
      errorMessage: '',
      // @ts-expect-error Ignore type mismatch.
      collectionDetails: INITIAL_COLLECTION_DETAILS_STATE,
      actionNotes: {
        actions: {},
        comment: {},
        orderId: 0,
      } as ActionNote,
      collectionTier: [] as CollectionsTier[],
      aTGLookupValue: [] as ATGLookupValue[],
      collectionComments: [] as IComment[],
    },
    'collectionDetailsStore',
  );

export { collectionDetailsStore, setCollectionDetailsStore };
